import api from '@common/api/index.js'
import { creatTreeData } from "@/utils/index.js";

const state = {
  treeObj: {}, //树数据
  notifyMsgTotal: 0,
  showTop: true,//是否显示头部的东西
  theme: 'theme-defalt'
};
const mutations = {
  //设置树数据
  SET_TREE_DATA (state, obj) {
    state.treeObj[obj.code] = creatTreeData(obj.nodes, 0);
  },
  //设置主题
  SET_THEME_DATA (state, obj) {
    state.theme = obj
  },
  SET_SHOW_TOP (state) {
    state.showTop = !state.showTop
  },
  SET_NOTIFY_MSG_TOTAL (state, data) {
    if (data >= 0) {
      state.notifyMsgTotal = data
    }
  }
};
const actions = {
  //获取树数据
  getTreeData (ctx, obj) {
    // return new Promise((resolve, reject) => {
    //     api.view.getViewTreeNodes(obj.code).then(res => {
    //         if (res) {
    //             ctx.commit('SET_TREE_DATA', { nodes: res.data, code: obj.code })
    //         }
    //         resolve(res)
    //     }).catch(error => {
    //         reject(error)
    //     })
    // })
  },
};
const getters = {
};

// 不要忘记把state, mutations等暴露出去。
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}